
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 9.07506L4.28598 5.2311C3.99192 4.92297 3.51461 4.92297 3.22055 5.2311C2.92648 5.53924 2.92648 6.03941 3.22055 6.34755L7.49782 10.7817C7.77555 11.0728 8.22516 11.0728 8.50218 10.7817L12.7795 6.34755C13.0735 6.03941 13.0735 5.53924 12.7795 5.2311C12.4854 4.92297 12.0081 4.92297 11.714 5.2311L8 9.07506Z","fill":"#10001F"}})])
          )
        }
      }
    